import { render } from "./Terminos.vue?vue&type=template&id=627e54c4&scoped=true"
import script from "./Terminos.vue?vue&type=script&lang=js"
export * from "./Terminos.vue?vue&type=script&lang=js"

import "./Terminos.vue?vue&type=style&index=0&id=627e54c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-627e54c4"]])

export default __exports__